/**
 * Toolbar class - showed horizontally on top of the whole editing mode of the Sitebuilder
 *
 * @depends jquery.js
 * @depends extendClass.js
 * events: hide / show
 * plugins : mobile preview, undo redo, logout ...
 *
 */
/*global Klazz, diy, jQuery */
var $ = require('jquery');
var Modernizr = require('Modernizr');
var PageUtil = require('../util/page');

var Toolbar, positionToolbar;

var previousPosition;

var TOOLBAR_HEIGHT = 38; // it's a known visual height, cannot be calculated because it contains the shaddow

positionToolbar = function () {
    $('#diyToolbar').css({
        position: 'fixed',
        left: '0',
        right: '0',
        top: '0'
    });

    $('#diyToolbar').trigger('diy-editor-toolbar-repositioned');
};

var scrollRefreshHandler = function() {
    var windowScroll = $(window).scrollTop(),
        isTouchEnabled = diy.context.type === 'editor' ?
            diy.editor.uiPreference.isPointerModeTouch() : Modernizr.touch;

    if (isTouchEnabled) {
        if(windowScroll < 0 || windowScroll >= document.documentElement.scrollHeight - window.innerHeight) {
            return;
        }
    }

    positionToolbar();
};

Toolbar = Klazz.extend({
    activated: false,
    options: {},

    isActive: function () {
        return this.activated === true;
    },

    initialize: function(options) {
        if (typeof options !== 'undefined' && options.length) {
            this.options = $.extend(true, {}, this.options, options); // note: we break object reference
        }

        // position the toolbar on the first load //
        this.draw();

        positionToolbar();
        this.activated = true;
    },

    draw: function() {
        var toolbarElement;

        toolbarElement = $(
            '<div class="diye"><div id="diyToolbar" class="diyEditorTopSpacer diyEditorTopFixedSpacer">' +
                '<div class="panels" >' +
                    '<div class="panel leftPanel"></div>' +
                    '<div class="panel rightPanel"></div>' +
                    '<div class="panel centerPanel"></div>' +
                '</div>' +
            '</div></div>'
        );
        $('body').prepend(toolbarElement);

        this.element = $('#diyToolbar');
        this.addContextClass();
        PageUtil.makeTopSpace(TOOLBAR_HEIGHT);

        // remove any leftover controls from the footer //
        $('#contentfooter .loggedin').remove();
    },

    addContextClass: function () {
        var className = '';

        switch (diy.context.type) {
            case 'web':
                className = 'diy-toolbar-web';
                break;
            case 'editor':
                className = 'diy-toolbar-editor';
                break;
            case 'mobilepreview':
                className = 'diy-toolbar-mobilePreview';
                break;
            default:
                throw new Error('Invalid context type');
        }

        this.element.addClass(className);
    },

    pushToPanel: function(panel, content, prepend) {
        var panelEl;

        if (!this.isActive()) {
            return false;
        }

        panelEl = $('#diyToolbar .' + panel + 'Panel');

        if (!prepend) {
            return $(content).appendTo(panelEl);
        } else {
            return $(content).prependTo(panelEl);
        }
    },

    getPanel: function(panel)
    {
        if (!this.isActive()) {
            return false;
        }
        return $('#diyToolbar .' + panel + 'Panel');
    },

    getElement: function() {
        return this.element;
    }

});

module.exports = Toolbar;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/toolbar.js
 ** module id = 843
 ** module chunks = 0 9 10
 **/